import React from "react";
import { Link } from "react-router-dom";

const Title = ({img,title,disc}) => {
  return (
    <div
      className="WhyBharat"
      style={{
        backgroundImage: `url(${img})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <ul>
        <li>
          <h1>
            {title}
          </h1>
          <h2>
            {" "}
          {disc}
          </h2>
          <li className="btn-explore">
            <Link to="/contact-us">Explore Acetians</Link>
          </li>
        </li>
      </ul>
    </div>
  );
};

export default Title;
